
(function(){
  if (window.__lafxReveal) return;
  window.__lafxReveal = 1;

  var MIN_VW    = 900;   /* below this the footer is most of the screen */
  var MAX_RATIO = 0.92;  /* and it must never be more than this much of it.
                            Raised from 0.62 on 17 Sep 2026: the Control Tower
                            layout is taller than the three-column one it
                            replaced, and at 0.62 the reveal silently switched
                            itself off on every laptop. The CSS shrinks the
                            phone, the links and the map under 1150px of
                            viewport height to keep the footer inside this
                            budget: measured 17 Sep 2026, 798px in a 900px-high
                            window and about 1040px on a display tall enough to
                            skip the compact set. A footer that fills most of
                            the last screen is the point of the reveal. If it
                            still does not fit, it falls back to a normal block
                            at the end of the page, which is the safe outcome. */

  var shell  = document.getElementById('lafx-shell');
  var spacer = document.getElementById('lafx-spacer');
  if (!shell || !spacer) return;

  var root = document.documentElement;
  var lifted = false;

  /* position:fixed resolves against the nearest ancestor that has a transform,
     filter, backdrop-filter, perspective or will-change — not the viewport. If
     one exists the footer would be pinned inside the page, so bail entirely. */
  function blockedByAncestor(){
    var el = shell.parentNode;
    while (el && el.nodeType === 1 && el !== document.body) {
      var s = window.getComputedStyle(el);
      if ((s.transform && s.transform !== 'none') ||
          (s.perspective && s.perspective !== 'none') ||
          (s.filter && s.filter !== 'none') ||
          (s.backdropFilter && s.backdropFilter !== 'none') ||
          (s.webkitBackdropFilter && s.webkitBackdropFilter !== 'none') ||
          (s.willChange && /transform|filter|perspective/.test(s.willChange)) ||
          (s.contain && /paint|layout|strict|content/.test(s.contain))) {
        return true;
      }
      el = el.parentNode;
    }
    return false;
  }

  /* ================================ THE LIFT ================================
     Everything before the footer group, at body level, has to paint over the
     fixed footer, and the page body has to be opaque or the footer shows
     through it while scrolling.

     THIS WAS WRONG UNTIL 17 SEP 2026 AND IT BROKE THE MEGA MENU. The first
     version put one class on every one of those siblings and styled it
     `position:relative; z-index:2`. That flattens the header group and <main>
     into the same layer, and <main> comes later in the document, so it won:
     the mega menu opened underneath the page and every click on it landed on
     the page instead. The header's own z-index:1000 could not help, because it
     was trapped inside its wrapper's new stacking context. It went unnoticed
     because MAX_RATIO was low enough that the reveal almost never switched on.

     Three rules now, and they are the whole fix:
       1. Z-INDEX DESCENDS down the document, so the header outranks the page
          body exactly as it did before anything was lifted. An element that
          already carries a higher z-index of its own (the glass nav's 10000)
          is left alone.
       2. POSITION is only set on elements that are `static`. The glass nav and
          its drawer are position:fixed and were being turned into relative,
          which moved them into the flow.
       3. THE BACKGROUND goes on the one element that holds <main>, not on all
          of them. Painting the header's wrapper white would have put a white
          band behind a header designed to sit transparent over a hero.
     Everything is recorded so unlift() can put it back. ==================== */
  var liftRecords = [];

  function transparent(c){
    return !c || c === 'transparent' || /rgba\([^)]*,\s*0\s*\)$/.test(c);
  }

  function lift(){
    if (lifted) return;

    var top = shell;
    while (top && top.parentNode && top.parentNode !== document.body) top = top.parentNode;
    if (!top || top.parentNode !== document.body) return;

    var before = [], el = top.previousElementSibling;
    while (el) {
      if (el.nodeType === 1 && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE' &&
          el.tagName !== 'LINK' && el.tagName !== 'TEMPLATE') before.unshift(el);
      el = el.previousElementSibling;
    }
    if (!before.length) return;

    lifted = true;

    /* The element at body level that carries the page body, for the background. */
    var mainEl = document.getElementById('main') || document.querySelector('main');
    var host = null;
    if (mainEl) {
      host = mainEl;
      while (host && host.parentNode && host.parentNode !== document.body) host = host.parentNode;
      if (host && host.parentNode !== document.body) host = null;
    }
    if (!host) {
      var tallest = 0;
      for (var t = 0; t < before.length; t++) {
        var hh = before[t].offsetHeight || 0;
        if (hh > tallest) { tallest = hh; host = before[t]; }
      }
    }

    var bodyBg = window.getComputedStyle(document.body).backgroundColor;
    if (transparent(bodyBg)) bodyBg = '#ffffff';

    var base = before.length + 1;
    for (var i = 0; i < before.length; i++) {
      var e = before[i];
      var cs = window.getComputedStyle(e);
      var want = base - i;
      var rec = { el: e, pos: e.style.position, z: e.style.zIndex, bg: e.style.backgroundColor };

      if (cs.position === 'static') e.style.position = 'relative';

      var cur = parseInt(cs.zIndex, 10);
      if (cs.zIndex === 'auto' || isNaN(cur) || cur < want) e.style.zIndex = String(want);

      if (e === host && transparent(cs.backgroundColor)) e.style.backgroundColor = bodyBg;

      e.classList.add('lafx-above');
      liftRecords.push(rec);
    }
  }

  function unlift(){
    if (!lifted) return;
    for (var i = 0; i < liftRecords.length; i++) {
      var r = liftRecords[i];
      r.el.style.position = r.pos || '';
      r.el.style.zIndex = r.z || '';
      r.el.style.backgroundColor = r.bg || '';
      r.el.classList.remove('lafx-above');
    }
    liftRecords = [];
    lifted = false;
  }

  /* THE FIT TIERS. The footer is measured in flow, and while it is over budget
     the next tier class is added and it is measured again. Each tier only
     tightens spacing, type and the map; see the CSS above. The loop is what
     keeps the reveal alive on a laptop window, where one fixed measurement used
     to fail by about 80px and switch the whole effect off. */
  var TIERS = ['lafx-fit1', 'lafx-fit2', 'lafx-fit3'];
  var expectedH = -1;

  function clearTiers(){
    for (var i = 0; i < TIERS.length; i++) root.classList.remove(TIERS[i]);
  }

  function apply(){
    var vw = window.innerWidth  || root.clientWidth;
    var vh = window.innerHeight || root.clientHeight;

    /* Measure against the static layout: out of flow the footer is as wide as
       the viewport rather than as wide as its column, which reads differently.
       Nothing paints between here and the end of this function. */
    root.classList.remove('lafx-reveal-on');
    clearTiers();

    var h = shell.offsetHeight;
    var ok = vw >= MIN_VW && h > 0 && !blockedByAncestor();

    if (ok) {
      for (var i = 0; i < TIERS.length && h > vh * MAX_RATIO; i++) {
        root.classList.add(TIERS[i]);
        h = shell.offsetHeight;
      }
      ok = h > 0 && h <= vh * MAX_RATIO;
    }

    if (ok) {
      lift();
      spacer.style.height = h + 'px';
      root.classList.add('lafx-reveal-on');
    } else {
      clearTiers();
      spacer.style.height = '';
      unlift();
    }

    /* What the footer measures once this pass has settled. The observer below
       compares against it so that the resize WE just caused does not start the
       whole negotiation again. */
    expectedH = shell.offsetHeight;
  }

  /* Measure once the footer has its real height, then keep it in step. The
     first pass runs against the static layout, which is what we want — the
     height is read before the footer is taken out of flow. */
  function boot(){
    apply();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function(){
        /* Ignore the height change this script just made itself. Without this
           the tier classes and the observer would chase each other. */
        if (expectedH >= 0 && Math.abs(shell.offsetHeight - expectedH) <= 2) return;
        apply();
      });
      ro.observe(shell);
    }
    window.addEventListener('resize', apply, { passive: true });
    window.addEventListener('load', apply);
    setTimeout(apply, 1200);
    setTimeout(apply, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
